import React, { useState } from "react";
import "./FAQ.css";
import landing11 from "../../../../images/landing11.jpg";
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // Icons
import { useNavigate } from "react-router-dom";
const faqs = [
  {
    question: "What is eBench?",
    answer:
      "eBench is a vendor-focused hiring platform that allows vendors to list their available candidates and enables companies to find the right talent through skills-based job matching. It streamlines recruitment, interviews, and resource allocation."
  },
  {
    question: "How do vendors use eBench?",
    answer:
      "Vendors can create profiles, list available candidates, showcase skills and experience, and post job opportunities. All vendor job postings go through an admin approval process before being visible to companies."
  },
  {
    question: "How does skills-based job matching work?",
    answer:
      "eBench matches candidates to open roles based on their skills, experience, and availability. This ensures that companies see the most relevant candidates while vendors get matched to the right opportunities."
  },
  {
    question: "Can eBench handle interviews?",
    answer:
      "Yes. eBench provides tools to schedule and conduct interviews directly on the platform, reducing back-and-forth emails and improving the candidate evaluation process."
  },
  {
    question: "Does eBench support purchase orders?",
    answer:
      "Absolutely. Companies can create and manage purchase orders for staffing requirements, ensuring clear agreements and smooth vendor payments."
  },
  {
    question: "Is there a free trial available?",
    answer:
      "Yes. We offer a free trial period so you can explore the features of eBench before committing to a subscription plan."
  },
  {
    question: "Does eBench support on-site and remote hiring?",
    answer:
      "Yes. eBench supports on-site, remote, and hybrid hiring models, helping companies and vendors manage workforce requirements efficiently."
  },
  {
    question: "How secure is candidate and vendor data on eBench?",
    answer:
      "eBench uses enterprise-grade security protocols, including encryption and access control, to ensure that all candidate and vendor data is safe and private."
  },
  {
    question: "Can vendors track the status of their job postings?",
    answer:
      "Yes. Vendors can see which jobs are approved, pending approval, or filled. This transparency ensures vendors know where their candidates stand in the hiring pipeline."
  },
  {
    question: "How does eBench reduce bench time for employees?",
    answer:
      "By tracking available candidates and using skills-based matching, eBench ensures employees are quickly assigned to relevant projects, reducing idle time and optimizing workforce utilization."
  },
   {
    question: "How is eBench different from other hiring platforms?",
    answer:
      "Unlike traditional platforms, eBench goes beyond recruitment. It helps companies track employee bench status, optimize resource allocation, and reduce downtime costs. Vendors can also post jobs (with admin approval) and showcase their talent pool to clients directly."
  }
];


const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section
      style={{
        backgroundImage: `url(${landing11})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      className="faq-section"
    >
      <h2 className="faq-heading">Frequently Asked Questions</h2>
      <p className="faq-subheading">
        Here are some of the most common queries businesses in India ask us about IoT solutions.
      </p>

      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question-wrapper">
              <h3 className="faq-question">{faq.question}</h3>
              <span className="faq-icon">
                {activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}
              </span>
            </div>
            <div
              className={`faq-answer-wrapper ${
                activeIndex === index ? "open" : ""
              }`}
            >
              <p className="faq-answer">{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="faq-footer">
        <p className="faq-bottom-text">
          Still have questions? Our India-based support team is here to help you 24/7.
        </p>
        <button className="contact-btn" onClick={()=>navigate("/contact-us")}>Contact Support</button>
      </div>
    </section>
  );
};

export default FAQ;
